import {ExtraReducer, ReducerFromState} from "../../../@types/reducers";
import {AlertExtraObject} from "../../../@types/response";

export const getExtras = (state: ReducerFromState<ExtraReducer>): Array<AlertExtraObject> => state.extra.extras;
